<template>
  <div id="page" :class="htmlAttrs">
    <!-- <SearchBarMobile v-if="!initDataPending" /> -->
    <SearchBarFlyMobile v-if="!initDataPending" />
    <QuickOrderModal v-if="!initDataPending && quickOrderModal" />
    <PreOrderModal v-if="!initDataPending && preOrderModal" />
    <ProductInfoModal v-if="!initDataPending && productInfoModal" />
    <NotifyStockModal v-if="!initDataPending && notifyStockModal" />
    <DeliveryModal />
    <CartNotice v-if="$store.getters.addedCartNotice" />
    <Preloader v-if="initDataPending" />
    <div id="main" v-else>
      <Header />
      <div id="middle">
        <HeadlineHeader v-if="!isHomeRoute" />
        <ContentWrapperWide v-if="isWideRoute">
          <transition name="fade" mode="out-in">
            <router-view />
          </transition>
        </ContentWrapperWide>
        <ContentWrapper v-else>
          <transition name="fade" mode="out-in">
            <router-view />
          </transition>
        </ContentWrapper>
      </div>
      <MainFooter />
      <!-- <Netpeak /> -->
      <ButtonSlideTop />
    </div>
    <Footer v-if="!initDataPending" />
    <Gallery v-if="!initDataPending" />
    <ButtonBackToTop />
  </div>
</template>

<style>
/*
@import './assets/css/cdf3f.css';
@import './assets/css/0fa4f.css';
@import './assets/css/b8ac5.css';
@import './assets/css/31e12.css';
@import './assets/css/63fe5.css';
@import './assets/css/bbb66.css';
@import './assets/css/main.css';
*/
/* @import '~@/assets/css/magicscroll.css'; */
@import '~@/assets/css/bootstrap.min.css';
@import '~@/assets/css/fonts.css';
@import '~@/assets/css/style.css';
@import '~@/assets/css/style1.css';
@import '~@/assets/css/style2.css';
@import '~@/assets/css/style3.css';
@import '~@/assets/css/style0.css';
@import '~@/assets/css/headers.css';
@import '~@/assets/css/adaptive.css';
@import '~@/assets/css/content.css';
@import '~@/assets/css/helpers.css';

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>

<script>
import { mapState } from 'vuex'
// @ is an alias to /src
import Preloader from '@/components/Preloader'
import Header from '@/components/header/Header'
import HeadlineHeader from '@/components/header/HeadlineHeader'
import MainFooter from '@/components/footer/MainFooter'
import Footer from '@/components/footer/Footer'
import ButtonSlideTop from '@/components/footer/ButtonSlideTop'
import ContentWrapper from '@/components/ContentWrapper'
import ContentWrapperWide from '@/components/ContentWrapperWide'
// import SearchBarMobile from '@/components/search/SearchBarMobile'
import SearchBarFlyMobile from '@/components/search/SearchBarFlyMobile'
import Gallery from '@/components/product/Gallery'
import QuickOrderModal from '@/components/order/QuickOrderModal'
import PreOrderModal from '@/components/order/PreOrderModal'
import ProductInfoModal from '@/components/product/ProductInfoModal'
import NotifyStockModal from '@/components/NotifyStockModal'
import DeliveryModal from '@/components/product/DeliveryModal'
import CartNotice from '@/components/product/CartNotice'
import ButtonBackToTop from '@/components/static/ButtonBackToTop'
// import Netpeak from '@/components/netpeak/Netpeak'

export default {
  name: 'App',
  components: {
    Preloader,
    Header,
    MainFooter,
    Footer,
    ButtonSlideTop,
    ContentWrapper,
    ContentWrapperWide,
    HeadlineHeader,
    // SearchBarMobile,
    SearchBarFlyMobile,
    Gallery,
    QuickOrderModal,
    PreOrderModal,
    ProductInfoModal,
    NotifyStockModal,
    DeliveryModal,
    CartNotice,
    ButtonBackToTop,
    // Netpeak,
  },
  data() {
    return {
      canonical: this.$h.getCanonical(),
    }
  },
  metaInfo() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale === 'ua' ? 'uk' : this.$i18n.locale,
      },
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: this.canonical,
        },
        {
          title: 'UA',
          dir: 'ltr',
          type: 'text/html',
          rel: 'alternate',
          hreflang: 'x-default',
          href: this.getAlternateLink('UA'),
        },
        {
          title: 'RU',
          dir: 'ltr',
          type: 'text/html',
          rel: 'alternate',
          hreflang: 'ru-UA',
          href: this.getAlternateLink('RU'),
        },
        {
          title: 'UA',
          dir: 'ltr',
          type: 'text/html',
          rel: 'alternate',
          hreflang: 'uk-UA',
          href: this.getAlternateLink('UA'),
        },
      ],
    }
  },
  methods: {
    getAlternateLink(title) {
      const ruLangKey = 'ru'
      const regx = new RegExp(`^/${ruLangKey}`, 'gm')
      const { pathname, origin } = window.location
      switch (title) {
        case 'RU':
          if (this.$route.params.lang === ruLangKey) {
            return `${origin}${pathname}`
          } else {
            return `${origin}/${ruLangKey}${pathname}`
          }
        case 'UA':
          return `${origin}${pathname.replace(regx, '')}`
      }
    },
    // updateCanonicalLink() {
    //   const head() = document.head.querySelector('link[rel="canonical"]')
    //   const canonicalHref = window.location.origin + window.location.pathname
    //   head.setAttribute('href', canonicalHref)
    // },
    //   updateAlternateLink() {
    //     const alternateLinks = document.head.querySelectorAll('link[rel="alternate"]')
    //     alternateLinks.forEach(link => {
    //       switch (link.title) {
    //         case 'RU':
    //           if (this.$route.params.lang === 'ru') {
    //             link.setAttribute(
    //               'href',
    //               `${window.location.origin}${window.location.pathname}`
    //             )
    //           } else {
    //             link.setAttribute(
    //               'href',
    //               `${window.location.origin}/ru${window.location.pathname}`
    //             )
    //           }
    //           break
    //         case 'UA':
    //           link.setAttribute(
    //             'href',
    //             `${window.location.origin}${window.location.pathname.replace('ru/', '')}`
    //           )
    //           break
    //       }
    //     })
    //   },
  },
  computed: {
    htmlAttrs() {
      return 'chrome_only seasidetms_liquid fullwidth fixed_header enable_header_top enable_header_bottom enable_header_left seasidetms_heading_under_header hfeed site'
    },
    isHomeRoute() {
      // console.log(this.$route.path)
      return (
        this.$route.path === '/' ||
        this.$route.path === '/ru' ||
        this.$route.path === '/ru/'
      )
    },
    isWideRoute() {
      return (
        this.$route.path === '/' ||
        this.$route.path === '/about-us/' ||
        this.$route.path === '/about-us' ||
        this.$route.path === '/ru/' ||
        this.$route.path === '/ru' ||
        this.$route.path === '/ru/about-us' ||
        this.$route.path === '/ru/about-us/'
      )
    },
    ...mapState([
      'initDataPending',
      'galleryModal',
      'quickOrderModal',
      'preOrderModal',
      'productInfoModal',
      'notifyStockModal',
    ]),
  },
  beforeMount() {
    const scripts = [
      // '/js/jquery.js',
      // '/js/js.cookie.min.js'
      // '/js/magicscroll.js'
    ]
    // if (this.$h.parseFalsy(this.$h.env('VUE_APP_WIDGET_GOOGLE', 'true'))) {
    //   scripts.push('/js/google.js')
    // }
    if (this.$h.parseFalsy(this.$h.env('VUE_APP_WIDGET_JIVOSITE', 'true'))) {
      scripts.push('/js/jivosite.js?v1')
    }
    if (this.$h.parseFalsy(this.$h.env('VUE_APP_WIDGET_BINOTEL', 'true'))) {
      scripts.push('/js/binotel.js')
    }
    scripts.forEach((src) => {
      if (/binotel/m.test(src)) {
        let s = document.createElement('script')
        s.setAttribute('src', src)
        const noindex = document.createElement('noindex')
        noindex.appendChild(s)
        document.head.appendChild(noindex)
      } else {
        let s = document.createElement('script')
        s.setAttribute('src', src)
        document.head.appendChild(s)
      }
    })
    /*setTimeout(() => {
      [
        '/js/main.js',
        '/js/initdata.js',
        '/js/jquery.mask.min.js',
        '/js/lazyload.min.js',
        '/js/bootstrap.min.js',
        '/js/6c119.js',
        '/js/5e649.js',
        '/js/9ae64.js',
        '/js/b2391.js',
        '/js/20d80.js',
        '/js/d151d.js',
        '/js/fc9b6.js',
        '/js/80f35.js',
        '/js/76d15.js',
        '/js/9ed74.js',
        '/js/cc291.js',
        '/js/6961e.js',
        '/js/67f0e.js',
        '/js/d9c4d.js',
        '/js/df6e2.js',
        '/js/w3tc.js',
        '/js/main2.js',
      ].forEach(src => {
        let s = document.createElement('script')
        s.setAttribute('src', src)
        document.head.appendChild(s)
      })
    }, 2000)*/
    this.$store.dispatch('fetchInitData')
    this.$store.dispatch('fetchRepair')

    let tempLang = window.location.pathname.substr(1, 2)

    if (tempLang === 'ru') {
      this.$store.dispatch('changeLang', 'ru')
      this.$locale = 'ru'
    }
  },
  watch: {
    '$store.state.category.page': {
      handler() {
        this.canonical = this.$h.getCanonical()
      },
      deep: true,
      immediate: true,
    },
    '$store.state.blog': {
      handler() {
        this.canonical = this.$h.getCanonical()
      },
      deep: true,
      immediate: true,
    },
  },
  updated() {
    // this.updateCanonicalLink()
    // this.updateAlternateLink()
    // this.$meta().refresh()
    this.canonical = this.$h.getCanonical()
    window?.BinotelCallTracking?.[509608]?.replacePhoneNumbersOnDynamicContent()
  },
}
</script>
